import type { ComputedVisibilityPayloadType } from '@unifyapps/defs/types/block';

export const isVisible = (visibility: ComputedVisibilityPayloadType | undefined) => {
  if (!visibility) return true;

  if (visibility.value === 'conditions') {
    return visibility.conditions !== false;
  }

  return visibility.value !== false;
};
